import useOfferStatusTranslations from "../../hooks/useOfferStatusTranslations";

export default function OfferStatus({ offer }) {
	const translations = useOfferStatusTranslations();

	return translations[offer.status];
}
